module.exports = __webpack_public_path__ + "img/V_one.b2bcfb52.png";